module.exports = __webpack_public_path__ + "img/icon-app-google.e76a27a.webp";